import i18n from '../../../app/i18n';
import Card from '../../../shared/Card';
import Table from '../../../shared/Table/Table.jsx';
import Placeholder from '../../../shared/Placeholder';
import useSort from '../../../shared/Sort/useSort';
import {
  columns,
  engagementBodyData,
} from '../components/Engagement/allTilesTableData.jsx';
import { useGetTileDigestTiles } from './data';

const DigestEngagementByTile = ({ digestId }) => {
  const {
    sortingStatus: digestEngagementSortingStatus,
    changeSort: changeDigestEngagementSort,
  } = useSort();

  const { data = { data: [] } } = useGetTileDigestTiles({
    digestId,
    ...digestEngagementSortingStatus,
  });

  return (
    <Card
      items={10}
      title={i18n.t('reports:engagementTable.tableTitle')}
      className="engagement-section"
      margin={'0px'}
    >
      {data.data.length ? (
        <Table
          columns={columns}
          body={engagementBodyData(data.data)}
          sortingStatus={digestEngagementSortingStatus}
          changeSort={changeDigestEngagementSort}
          minWidthBeforeScroll="1290px"
        />
      ) : (
        <Placeholder />
      )}
    </Card>
  );
};

export default DigestEngagementByTile;
